export default __webpack_public_path__ + "/src/assets/images/health_red_notext.svg";